export default __webpack_public_path__ + "static/media/7.3af445fb.png";